import { Action, State, StateContext, Store } from "@ngxs/store";
import { Injectable } from "@angular/core";
import { LocalizationService } from "src/app/services/localization/localization.service";
import { AlertService } from "src/app/shared/store/alert/alert.service";
import { MappingUtilsService } from "src/app/services/utils/mapping-utils.service";
import { Cycle } from "../models/cycle.model";
import { CycleService } from "../services/cycle.service";
import { CycleActions } from "./cycle.actions";


export class CycleStateModel {
    public cycles: Cycle[];
    public error: string;
  }

  const defaults = {
    cycles: [],
    error: '',
  };

  @State<CycleStateModel>({
    name: 'cycle',
    defaults,
  })
  @Injectable()
  export class CycleState {
    constructor(
      private alertService: AlertService,
      private localizationService: LocalizationService,
      public store: Store,
      private cycleService: CycleService
    ) {}

    @Action(CycleActions.GetCycles) getCycles(ctx: StateContext<CycleStateModel>, {}: CycleActions.GetCycles) {
      return this.cycleService.getCycles().subscribe({
        next: (response) =>
          ctx.dispatch(new CycleActions.GetCyclesSuccess(response)),
        error: (error) =>
          ctx.dispatch(new CycleActions.GetCyclesFail(error)),
      });
    }

    @Action(CycleActions.GetCyclesSuccess)
    getCyclesSuccess(ctx: StateContext<CycleStateModel>, { cycles }: CycleActions.GetCyclesSuccess) {
      ctx.patchState({
        cycles: cycles
      });
    }

    @Action(CycleActions.GetCyclesFail)
    getCyclesFailed(ctx: StateContext<CycleStateModel>, { error }: CycleActions.GetCyclesFail) {
      ctx.patchState({
        error: error,
      });
      MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
    }

    private getTitle() {
      return this.localizationService.translate('cycles.title');
    }
  }
